import { COUNTRY } from './constants/RequestedDataTypes';
import { createRequestTypes, createRequestActions } from './helpers/RequestActions';
import makeFetchRequest from './helpers/makeFetchRequest';
import { fetchCountry } from 'pricing-pages-lib/api/fetchCountry';
export const FetchCountryRequestTypes = createRequestTypes(COUNTRY);
export const FetchCountryActions = createRequestActions(FetchCountryRequestTypes);
export const getCountry = () => makeFetchRequest({
  requestActions: FetchCountryActions,
  fetch: fetchCountry
});